import React from "react";
import { Link, Navigate } from "react-router-dom";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import FameWallPte from "../components/Frontend/FameWallPte";
import Testimonial from "../components/Frontend/Testimonial";
import VideoTuts from "../components/Frontend/VideoTuts";
import WhyLove from "../components/Frontend/WhyLove";
import SimpleReactValidator from "simple-react-validator";
import { store } from "store/index";
import { setAlert } from "action/index.js";
import API from "api.js";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import FameWall from "../components/Frontend/FameWallIelts";
import ReactPixel from "react-facebook-pixel";
import TestimonialVid from "../components/Frontend/VideoIeltsTestimonial";
import Slider from "react-slick";
import PhoneInputField from "components/Inputs/PhoneInputField";
import CrackedCodeSlider from "../components/Frontend/Sliders/CrackedCodeSlider";

class Pte extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
      name: "",
      email: "",
      phone: "",
      course: "IELTS Online",
      lang: "Hindi",
      query: "",
      flag: false,
      loginLock: false,
      readMoreFlag: false,
      homePage: false,
      list: [],
      sliderStyles: { marginLeft: "0px", width: "100%" },
    };
    this.validator = new SimpleReactValidator();
    this.sliderRef = React.createRef();
  }
  handleClick = () => {
    this.setState((prevState) => ({
      isActive: !prevState.isActive,
    }));
  };
  submitForm = (e) => {
    e.preventDefault();
    this.hitApi();
  };

  hitApi = async () => {
    if (this.state.loginLock) {
      return;
    }
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
      return;
    }
    this.setState({ loginLock: true });

    var bodyFormData = new FormData();
    bodyFormData.set("email", this.state.email);
    bodyFormData.set("name", this.state.name);
    bodyFormData.set("phone", this.state.phone);
    bodyFormData.set(
      "message",
      "<b>course:</b> " +
        this.state.course +
        "<br/><b>Query:</b> " +
        this.state.query
    );
    bodyFormData.set(
      "data",
      "email: " +
        this.state.email +
        ",name: " +
        this.state.name +
        ",phone: " +
        this.state.phone +
        ",course: " +
        this.state.course +
        ",query: " +
        this.state.query
    );
    bodyFormData.set("page", "IELTS coaching parramatta");
    let res = null;
    try {
      res = await API({
        method: "POST",
        url: "sendOnlinePte",
        data: bodyFormData,
      });
    } catch (error) {}
    console.log(res);
    if (res?.status === 200) {
      store.dispatch(
        setAlert({ flag: true, type: 1, message: res.data.message })
      );
      this.setState({
        name: "",
        email: "",
        phone: "",
        course: "PTE On-Campus",
        query: "",
        loginLock: false,
        flag: true,
      });
    } else {
      this.setState({ loginLock: false });
    }
  };

  changeReadMore = () => {
    this.setState({ readMoreFlag: !this.state.readMoreFlag });
  };

  changeInput = (e) => {
    let { name, value } = e.target;
    this.setState({ [name]: value });
  };
  render() {
    if (this.state.flag) {
      return <Navigate to="/thank-you" replace />;
    }

    const Turorialvideos = {
      dots: false,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 5,
      // slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            dots: true,
            arrows: true,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            dots: true,
            arrows: true,
          },
        },
      ],
    };

    const CardsSlider = {
      dots: true,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      adaptiveHeight: true,
      autoplaySpeed: 5000,
    };

    return (
      <React.Fragment>
        <Helmet>
          <title>IELTS Coaching Classes in Parramatta | Language Academy</title>
          <meta
            name="twitter:title"
            content="IELTS Classes in Parramatta - Language Academy"
          />
          <meta
            property="og:title"
            content="IELTS Classes in Parramatta - Language Academy"
          />
          <meta
            name="description"
            content="Attend IELTS coaching classes in Parramatta with Language Academy. Get personalized instruction and comprehensive practice to excel in your IELTS exam."
          />

          <meta
            name="twitter:description"
            content="Language Academy is a leading training Institute for IELTS Courses Online. Book your IELTS demo class with Language Academy now. Contact us at +61 426230061."
          />
          <meta
            property="og:description"
            content="Language Academy is a leading training Institute for IELTS Courses Online. Book your IELTS demo class with Language Academy now. Contact us at +61 426230061."
          />
        </Helmet>
        <div className="innerPage">
          <Header />
          <div className="banner-section noc-banner">
            <div className="container">
              <div className="row">
                <div className="banner-content">
                  <h1 className="primary-heading dark-blue-color">
                    ACHIEVE YOUR TARGET
                    <br className="d-block" />
                    <span className="wpl-badge pte-naati-badge text-white">
                      IELTS BAND SCORE</span><br className="d-block d-md-none" /> WITH <br className="d-none d-md-block" /> PARRAMATTA'S LEADING <br className="d-none d-md-block" /> COACHING EXPERTS
                  </h1>
                  <p className="sub-title">
                    Expert instruction, proven strategies, and personalized
                    support
                    <br />
                    to help you achieve the band scores that open doors
                    worldwide.
                  </p>
                  <div className="iframe-video-outer position-relative">
                    <div className="banner-img-wrapper">
                      <img
                        className="banner-img"
                        src="/images/web-new-images/banners/ielts-banner.png"
                        alt="LA"
                      />
                    </div>
                    <img
                      className="emoji1 position-absolute"
                      src="/images/web-new-images/emojis/emoji-1.png"
                      alt="LA"
                    />
                    <img
                      className="emoji2 position-absolute"
                      src="/images/web-new-images/emojis/emoji-2.png"
                      alt="LA"
                    />
                    <img
                      className="emoji3 position-absolute"
                      src="/images/web-new-images/emojis/emoji-3.png"
                      alt="LA"
                    />
                    <img
                      className="emoji4 position-absolute"
                      src="/images/web-new-images/emojis/emoji-4.png"
                      alt="LA"
                    />
                  </div>
                  <div className="light-blue-box">
                    Achieve your dream IELTS band score and unlock opportunities
                    with expert coaching tailored for students, language
                    learners, and IELTS candidates.
                    <br />
                    <br />
                    As Parramatta's top-rated IELTS institute, we specialize in
                    personalized strategies to help you improve your English
                    skills, ace the IELTS exam, and reach your goals, whether
                    it's qualifying for migration, pursuing higher education, or
                    enhancing your career prospects.
                  </div>                 
                  <Link className="primary-btn" to="/auth/register">
                      <span className="btn-inner">
                        ENROLL IN OUR COMPREHENSIVE IELTS PROGRAM TODAY
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="Register Now"
                        />
                      </span>
                    </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="noc-ccl-exam naati-ccl-exam what-ielts">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-12">
                  <h2 className="primary-heading text-center fw-700">
                    <span className="wpl-badge text-white">WHAT IS IELTS?</span>
                    <br className="d-block" />
                    YOUR GATEWAY <br /> TO A BRIGHTER FUTURE
                  </h2>
                </div>
                <div className="col-md-6">
                  <div className="ccl-exam-img">
                    <img
                      src="/images/web-new-images/ielts-img.png"
                      alt="Register Now"
                    />
                  </div>
                </div>
                <div className="col-md-6 what-ielts-content">
                  <p>
                    The International English Language Testing System (IELTS) is
                    a globally recognized English proficiency test designed for
                    academic, professional, and migration purposes.
                    <br />
                    <br />
                    IELTS assesses and gives an internationally recognized
                    certificate to people successfully qualifying it. Like other
                    countries, the Australian government also accepts IELTS
                    valid scores as a prerequisite for migrating to Australia.
                    <br />
                    <br />
                    Accepted by universities, immigration authorities, and
                    employers worldwide, IELTS assesses your ability to
                    communicate effectively in English across four core skills
                    —listening, reading, writing, and speaking.
                  </p>
                </div>
              </div>
              <div className="pc-skill-areas">
                <h2 className="pc-pte-core-title">
                  IELTS Exam Tests Four Key Skills
                </h2>
                <div className="skill-areas-content">
                  <div className="left-area">
                    <h2>Skill Area</h2>
                    <ul>
                      <li>Speaking</li>
                      <li>Writing</li>
                      <li>Reading</li>
                      <li>Listening</li>
                    </ul>
                  </div>
                  <div className="right-area">
                    <h2>What It Tests</h2>
                    <ul>
                      <li>Pronunciation, fluency, and clear communication</li>
                      <li>Grammar, essay composition, and task completion</li>
                      <li>Comprehension, vocabulary, and critical analysis</li>
                      <li>
                        Understanding accents, identifying key points, and
                        following instructions
                      </li>
                    </ul>
                  </div>
                </div>

                <p>
                  <strong>
                    The IELTS exam score ranges between 0 and 9 <br /> and the
                    exam is conducted in two categories
                  </strong>
                  <br />
                  <br />
                  General and Academic. Students migrating to Parramatta,
                  Australia to attend a course can opt for IELTS Academic.
                  Whereas, anyone migrating for all other non-educational
                  purposes can take IELTS General.
                  <br />
                  <br />
                  IELTS also helps candidates qualify for migration and academic
                  opportunities in countries like Australia, the UK, Canada, and
                  more.
                  <br />
                  <br />
                  With the right preparation and expert guidance, you won't just
                  pass the exam, you'll gain the confidence and skills to thrive
                  in any English-speaking environment.
                </p>
                <div className="text-center">
                  <Link className="primary-btn" to="/auth/register">
                    <span className="btn-inner">
                      BEGIN YOUR IELTS SUCCESS JOURNEY WITH US TODAY
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="choice-ielts">
            <div className="container">
              <div className="row">
                <h2 className="primary-heading dark-blue-color text-center fw-700">
                  <span className="wpl-badge text-white">
                    WHY CHOOSE IELTS?
                  </span>
                  <br className="d-block" />
                  HERE'S WHY IT'S THE RIGHT <br className="d-none d-md-block" /> CHOICE FOR YOU
                </h2>
                <div className="plan-cards d-none d-md-flex">
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>
                          Global <br /> Recognition
                        </h2>
                        <p>
                          Accepted by over 11,000 institutions worldwide,
                          including top universities and government organizations.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>
                          Multiple Test <br /> Variants
                        </h2>
                        <p>
                          Choose between Academic (for education) or General
                          Training (for migration or work).
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>
                          Comprehensive <br /> Assessment
                        </h2>
                        <p>
                          Evaluate all four skills to ensure you're fully prepared
                          for real-world communication.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>Flexible Test Dates</h2>
                        <p>
                          Schedule your IELTS exam at your convenience throughout
                          the year.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="plan-card-outer">
                    <div className="plan-card">
                      <div className="icon-wrapper">
                        <svg
                          width="18"
                          height="14"
                          viewBox="0 0 18 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17 1.49072L6 12.4907L1 7.49072"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="content-wrapper">
                        <h2>Aligned with Migration Goals</h2>
                        <p>
                          Fulfill your requirements for migration or professional
                          opportunities with targeted band scores.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="slider-dot-arrow d-block d-md-none mobile-slider">
                    <Slider {...CardsSlider} className="plan-cards">
                      <div className="plan-card-outer">
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <h2>
                            Global <br /> Recognition
                          </h2>
                          <p>
                            Accepted by over 11,000 institutions worldwide,
                            including top universities and government organizations.
                          </p>
                        </div>
                      </div>
                      </div>
                      <div className="plan-card-outer">
                        <div className="plan-card">
                          <div className="icon-wrapper">
                            <svg
                              width="18"
                              height="14"
                              viewBox="0 0 18 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17 1.49072L6 12.4907L1 7.49072"
                                stroke="#48A75C"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <div className="content-wrapper">
                            <h2>
                              Multiple Test <br /> Variants
                            </h2>
                            <p>
                              Choose between Academic (for education) or General
                              Training (for migration or work).
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="plan-card-outer">
                        <div className="plan-card">
                          <div className="icon-wrapper">
                            <svg
                              width="18"
                              height="14"
                              viewBox="0 0 18 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17 1.49072L6 12.4907L1 7.49072"
                                stroke="#48A75C"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <div className="content-wrapper">
                            <h2>
                              Comprehensive <br /> Assessment
                            </h2>
                            <p>
                              Evaluate all four skills to ensure you're fully prepared
                              for real-world communication.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="plan-card-outer">
                        <div className="plan-card">
                          <div className="icon-wrapper">
                            <svg
                              width="18"
                              height="14"
                              viewBox="0 0 18 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17 1.49072L6 12.4907L1 7.49072"
                                stroke="#48A75C"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <div className="content-wrapper">
                            <h2>Flexible Test Dates</h2>
                            <p>
                              Schedule your IELTS exam at your convenience throughout
                              the year.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="plan-card-outer">
                        <div className="plan-card">
                          <div className="icon-wrapper">
                            <svg
                              width="18"
                              height="14"
                              viewBox="0 0 18 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17 1.49072L6 12.4907L1 7.49072"
                                stroke="#48A75C"
                                strokeWidth="1.8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                          <div className="content-wrapper">
                            <h2>Aligned with Migration Goals</h2>
                            <p>
                              Fulfill your requirements for migration or professional
                              opportunities with targeted band scores.
                            </p>
                          </div>
                        </div>
                      </div>
                    </Slider>
                </div>
              </div>
              <div className="row">
                <div className="col-md-7">
                  <p className="light-blue-box">
                    Don't let inadequate preparation or generic study materials
                    hold you back. IELTS is the first step toward achieving your
                    dreams, let us guide you every step of the way.
                  </p>
                </div>
                <div className="col-md-5 text-center text-md-end">
                  <Link className="primary-btn" to="/auth/register">
                    <span className="btn-inner">
                      GET STARTED WITH OUR IELTS TRAINING TODAY
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="noc-ccl-exam naati-ccl-exam ielts-training">
            <div className="container">
              <div className="row">
                <div className="col-md-12 ielts-training-header">
                  <h2 className="primary-heading text-center fw-700">
                    <span className="wpl-badge gold-badge text-white">
                      IELTS TRAINING
                    </span><br className="d-block d-md-none" /> IN PARRAMATTA
                    <br className="d-block" />
                    THE PERFECT PLACE TO PREPARE!
                  </h2>
                  <p className="sub-title text-center">
                    Parramatta is a thriving hub for education, offering IELTS{" "}
                    <br /> candidates the perfect blend of resources and
                    opportunities.
                  </p>
                  <p className="light-blue-box">
                    This vibrant city is home to a diverse community of students
                    and professionals, making it an ideal place for language
                    learners aiming to excel in English. With its supportive
                    environment and easy access to resources, Parramatta
                    empowers learners to achieve their IELTS goals.
                  </p>
                </div>
                <div className="col-md-6">
                  <div className="ccl-exam-img">
                    <img
                      src="/images/web-new-images/ielts-img-01.png"
                      alt="Register Now"
                    />
                  </div>
                  <h2 className="content-title">
                    Our Convenient <br /> Parramatta Location
                  </h2>
                  <p>
                    Language Academy's Parramatta campus is located at the
                    center of the city at 22 Horwood Place in Suite 22, right
                    next to George Street.
                    <br />
                    <br />
                    The building has numerous food and beverage outlets nearby,
                    and we provide secured parking for all students and experts
                    right in the basement of our building.
                  </p>
                </div>
                <div className="col-md-6 what-ielts-content">
                  <h2 className="content-title">Easy Access</h2>
                  <ul className="circle-list">
                    <li>
                      Short walk from the bus stop <br /> at Parramatta
                      interchange
                    </li>
                    <li>
                      Parramatta station is just a short <br /> walk from the
                      campus
                    </li>
                    <li>
                      Public transport facilities can be easily accessed in just
                      a few minutes
                    </li>
                  </ul>
                  <h2 className="content-title">Whether you're planning on</h2>
                  <ul className="circle-list">
                    <li>Migrating to an English-speaking country</li>
                    <li>Pursuing higher education abroad</li>
                    <li>Advancing your career opportunities</li>
                  </ul>
                  <p className="light-blue-box">
                    Language Academy is your trusted partner for IELTS
                    preparation in Parramatta, helping students reach their
                    ultimate goal of achieving high band scores with confidence.
                  </p>
                  <div className="text-center text-md-start">
                    <Link className="primary-btn" to="/contact">
                      <span className="btn-inner">
                        DISCOVER WHY PARRAMATTA STUDENTS CHOOSE US
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="Register Now"
                        />
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="noc-ccl-exam naati-ccl-exam ielts-training-second">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-12">
                  <h2 className="primary-heading text-center fw-700">
                    <span className="wpl-badge pte-naati-badge text-white">IELTS TRAINING</span><br className="d-block d-md-none" /> IN PARRAMATTA <br className="d-block" /> WITH LANGUAGE
                    ACADEMY
                  </h2>
                </div>
                <div className="col-md-6">
                  <div className="ccl-exam-img">
                    <img
                      src="/images/web-new-images/ielts-img-02.png"
                      alt="Register Now"
                    />
                  </div>
                </div>
                <div className="col-md-6 what-ielts-content">
                  <p>
                    At Language Academy, our IELTS training course is proven to
                    be quite effective in improving our students' English
                    acumen. Expert faculties with finest subject matter
                    expertise and best teaching methodology create personalized
                    curriculum for each student.
                    <br />
                    <br />
                    Students can quickly start peaking their scores as our
                    stringent curriculum includes a lot of practice, assessment,
                    and feedback. We get an immensely large number of positive
                    reviews for our impeccable IELTS training in Parramatta.
                    <br />
                    <br />
                    Learners attending our IELTS training course praise us a lot
                    and even share with us how much they enjoy taking part in
                    all dimensions of English activities. They tell us that they
                    even excel at times in different sorts of personal,
                    professional, and cultural activities.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="ielts-success">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="primary-heading fw-700">
                    THE PERSONALIZED PATH <br /> TO IELTS SUCCESS IN PARRAMATTA
                  </h2>
                  <p className="sub-title">
                    Struggling with IELTS preparation or worried about securing
                    your target band scores? You're not alone. Many students
                    face similar challenges, but at Language Academy, our
                    coaching is designed to help you
                  </p>
                  <div className="plan-cards">
                    <div className="plan-card-outer">
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <h2>
                            Boost your English <br /> proficiency
                          </h2>
                          <p>
                            across all key skills, Listening, Reading, Writing,
                            and Speaking.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="plan-card-outer">
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <h2>
                            Build thorough <br /> preparation strategies
                          </h2>
                          <p>for every section of the IELTS exam.</p>
                        </div>
                      </div>
                    </div>
                    <div className="plan-card-outer">
                      <div className="plan-card">
                        <div className="icon-wrapper">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.49072L6 12.4907L1 7.49072"
                              stroke="#48A75C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                        <div className="content-wrapper">
                          <h2>
                            Gain <br /> confidence
                          </h2>
                          <p>to tackle high-pressure test environments.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-center text-md-start">
                    <Link className="primary-btn" to="/auth/register">
                      <span className="btn-inner">
                        EXPERIENCE OUR PROVEN APPROACH
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="Register Now"
                        />
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="ielts-coaching">
            <div className="container">
              <div className="row">
                <div className="ielts-coaching-header text-center">
                  <h2 className="primary-heading fw-700">
                    WHAT MAKES US YOUR BEST <br /> CHOICE FOR{" "}
                    <span className="wpl-badge gold-badge text-white">
                      IELTS
                    </span>{" "}
                    COACHING <br /> CLASSES IN PARRAMATTA?
                  </h2>
                  <p className="sub-title">
                    Parramatta offers access to numerous English training
                    facilities, and Language Academy is proud to stand out as
                    one of the most trusted IELTS coaching centers in the area.
                    IELTS classes in Parramatta like Language Academy offer both
                    online and offline courses.
                  </p>
                </div>
                <div className="ielts-coaching-cards">
                  <div className="ielts-coaching-card card1">
                    <p>
                      With our modern classrooms, expert tutors, and tailored
                      coaching solutions, we ensure that every student receives
                      personalized support based on their strengths and
                      weaknesses.
                    </p>
                    <h2 className="sub-title">
                      Here's how we guarantee your success
                    </h2>
                    <ul>
                      <li>
                        Comprehensive study materials and simulated test
                        environments to build familiarity and confidence
                      </li>
                      <li>
                        Expert-led 1:1 coaching sessions to focus on individual
                        improvement areas
                      </li>
                      <li>
                        Proven strategies that help our students consistently
                        achieve their desired band scores
                      </li>
                    </ul>
                  </div>
                  <div className="ielts-coaching-card card2">
                    <h2 className="title">
                      YOUR BENEFITS WITH <br /> LANGUAGE ACADEMY
                    </h2>
                    <ul>
                      <li>
                        <h3>Personalized Study Plans</h3>
                        <p>
                          Targeted strategies to help you maximize your
                          potential.
                        </p>
                      </li>
                      <li>
                        <h3>Real-Time Test Simulations</h3>
                        <p>
                          Experience the exact pressure of an IELTS test
                          environment.
                        </p>
                      </li>
                      <li>
                        <h3>Unlimited Practice Tests</h3>
                        <p>
                          Refine your skills with comprehensive materials and
                          assessments.
                        </p>
                      </li>
                      <li>
                        <h3>1:1 Tutorials with Experts</h3>
                        <p>Get personalized guidance for every exam section.</p>
                      </li>
                      <li>
                        <h3>Confidence-Boosting Sessions</h3>
                        <p>Overcome exam stress and perform at your best.</p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <p className="text-white">
                    Stop struggling and start succeeding with Language Academy,
                    where expert training and proven techniques come together
                    for your IELTS success.
                  </p>
                </div>
                <div className="col-md-6 text-center text-md-end">
                  <Link className="primary-btn" to="/auth/register">
                    <span className="btn-inner">
                      BOOK YOUR CONSULTATION TODAY
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </span>
                  </Link>
                </div>
              </div>

              <div className="noc-why-choose why-most-section">
                <div className="container">
                  <div className="row why-most-second-row">
                    <div className="col-lg-6 why-most-content">
                      <h2 className="primary-heading fw-700">
                        WHY CHOOSE
                        <br />
                        LANGUAGE ACADEMY
                        <br />
                        <span className="wpl-badge text-white">IELTS</span>{" "}
                        TRAINING
                        <br />
                        IN PARRAMATTA
                      </h2>
                      <Link className="primary-btn" to="/auth/register">
                        <span className="btn-inner">
                          REGISTER FOR A FREE TRIAL SESSION FOR IELTS
                          <img
                            src="/images/web-new-images/right-arrow.svg"
                            alt="Register Now"
                          />
                        </span>
                      </Link>
                    </div>
                    <div className="col-lg-6">
                      <div className="why-most-list">
                        <ul>
                          <li className="list1">
                            <span className="list-counting">
                              <svg
                                width="30"
                                height="31"
                                viewBox="0 0 30 31"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M19.9847 6.99798L22.4736 9.48687L27.4514 4.50909M27.4514 15.7091V22.1802C27.4514 24.2711 27.4514 25.3165 27.0445 26.1151C26.6866 26.8176 26.1154 27.3887 25.413 27.7466C24.6144 28.1535 23.5689 28.1535 21.4781 28.1535H8.53583C6.44497 28.1535 5.39954 28.1535 4.60094 27.7466C3.89846 27.3887 3.32734 26.8176 2.96941 26.1151C2.5625 25.3165 2.5625 24.2711 2.5625 22.1802V9.23798C2.5625 7.14712 2.5625 6.10169 2.96941 5.30308C3.32734 4.60061 3.89846 4.02948 4.60094 3.67156C5.39954 3.26465 6.44497 3.26465 8.53583 3.26465H15.0069M2.74358 25.573C3.3274 23.4727 5.25369 21.9313 7.53999 21.9313H16.2511C17.4076 21.9313 17.9858 21.9313 18.4667 22.027C20.4413 22.4197 21.9849 23.9633 22.3777 25.938C22.4733 26.4188 22.4733 26.9971 22.4733 28.1535M17.4958 12.598C17.4958 15.3471 15.2672 17.5758 12.5181 17.5758C9.76891 17.5758 7.54028 15.3471 7.54028 12.598C7.54028 9.84883 9.76891 7.6202 12.5181 7.6202C15.2672 7.6202 17.4958 9.84883 17.4958 12.598Z"
                                  stroke="#7F56D9"
                                  strokeWidth="1.86667"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                            <div>
                              <h3>EXPERIENCED TRAINERS</h3>
                              <p>
                                They are adept at both linguistics skills and
                                imparting educational lectures both online and
                                in-person.
                              </p>
                            </div>
                          </li>
                          <li className="list2">
                            <span className="list-counting">
                              <svg
                                width="30"
                                height="31"
                                viewBox="0 0 30 31"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9.86398 20.0148L8.78299 28.1535L14.493 24.7275C14.6792 24.6158 14.7723 24.5599 14.8718 24.5381C14.9597 24.5188 15.0507 24.5188 15.1387 24.5381C15.2381 24.5599 15.3312 24.6158 15.5174 24.7275L21.2274 28.1535L20.1472 20.0113M20.513 6.06325C20.7052 6.52808 21.0741 6.89755 21.5386 7.09045L23.1674 7.76516C23.6323 7.95771 24.0016 8.32704 24.1941 8.7919C24.3867 9.25676 24.3867 9.77908 24.1941 10.2439L23.5199 11.8717C23.3273 12.3367 23.327 12.8596 23.5205 13.3244L24.1936 14.9517C24.289 15.1819 24.3382 15.4287 24.3382 15.6779C24.3383 15.9272 24.2892 16.174 24.1938 16.4043C24.0984 16.6345 23.9586 16.8437 23.7824 17.02C23.6061 17.1962 23.3968 17.3359 23.1665 17.4312L21.5389 18.1055C21.0741 18.2977 20.7046 18.6666 20.5117 19.1311L19.837 20.76C19.6445 21.2249 19.2752 21.5942 18.8103 21.7867C18.3455 21.9793 17.8232 21.9793 17.3583 21.7867L15.7307 21.1125C15.2658 20.9204 14.7437 20.9208 14.2791 21.1136L12.6503 21.7874C12.1857 21.9795 11.6639 21.9793 11.1994 21.7869C10.735 21.5945 10.3658 21.2256 10.1732 20.7613L9.49828 19.1319C9.30609 18.667 8.93718 18.2976 8.47267 18.1047L6.84383 17.43C6.37919 17.2375 6.00998 16.8684 5.81737 16.4038C5.62475 15.9392 5.62449 15.4171 5.81664 14.9524L6.49084 13.3246C6.68291 12.8598 6.68252 12.3376 6.48975 11.873L5.81652 10.243C5.72106 10.0127 5.67191 9.76595 5.67188 9.51671C5.67184 9.26746 5.72091 9.02066 5.81628 8.79039C5.91166 8.56012 6.05148 8.3509 6.22774 8.17468C6.404 7.99847 6.61326 7.85872 6.84355 7.76341L8.47122 7.08918C8.93562 6.89715 9.30486 6.5287 9.49789 6.0647L10.1726 4.4358C10.3651 3.97094 10.7344 3.60161 11.1993 3.40906C11.6641 3.21651 12.1864 3.21651 12.6513 3.40906L14.2789 4.08329C14.7438 4.27537 15.2659 4.27497 15.7305 4.0822L17.36 3.41011C17.8248 3.21766 18.3469 3.2177 18.8117 3.41022C19.2765 3.60273 19.6457 3.97195 19.8383 4.43669L20.5132 6.06608L20.513 6.06325Z"
                                  stroke="#0286FF"
                                  strokeWidth="1.86667"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                            <div>
                              <h3>HIGHEST SUCCESS RATE</h3>
                              <p>
                                With detailed and well-planned learning modules,
                                we are able to give the best training to our
                                students, and they are constantly achieving 8+
                                band scores.
                              </p>
                            </div>
                          </li>
                          <li className="list3">
                            <span className="list-counting">
                              <svg
                                width="28"
                                height="25"
                                viewBox="0 0 28 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M14.0069 23.9088L13.8824 23.722C13.018 22.4254 12.5858 21.777 12.0147 21.3077C11.5092 20.8922 10.9267 20.5804 10.3005 20.3903C9.59321 20.1755 8.81401 20.1755 7.25561 20.1755H5.54472C4.15081 20.1755 3.45386 20.1755 2.92146 19.9042C2.45314 19.6656 2.07239 19.2848 1.83377 18.8165C1.5625 18.2841 1.5625 17.5871 1.5625 16.1932V5.49101C1.5625 4.0971 1.5625 3.40015 1.83377 2.86775C2.07239 2.39943 2.45314 2.01868 2.92146 1.78006C3.45386 1.50879 4.15081 1.50879 5.54472 1.50879H6.0425C8.83032 1.50879 10.2242 1.50879 11.289 2.05133C12.2257 2.52857 12.9872 3.29007 13.4644 4.2267C14.0069 5.29151 14.0069 6.68542 14.0069 9.47323M14.0069 23.9088V9.47323M14.0069 23.9088L14.1315 23.722C14.9959 22.4254 15.4281 21.777 15.9992 21.3077C16.5047 20.8922 17.0872 20.5804 17.7134 20.3903C18.4207 20.1755 19.1999 20.1755 20.7583 20.1755H22.4692C23.8631 20.1755 24.56 20.1755 25.0924 19.9042C25.5608 19.6656 25.9415 19.2848 26.1801 18.8165C26.4514 18.2841 26.4514 17.5871 26.4514 16.1932V5.49101C26.4514 4.0971 26.4514 3.40015 26.1801 2.86775C25.9415 2.39943 25.5608 2.01868 25.0924 1.78006C24.56 1.50879 23.8631 1.50879 22.4692 1.50879H21.9714C19.1836 1.50879 17.7897 1.50879 16.7249 2.05133C15.7882 2.52857 15.0267 3.29007 14.5495 4.2267C14.0069 5.29151 14.0069 6.68542 14.0069 9.47323"
                                  stroke="#94C23C"
                                  strokeWidth="1.86667"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                            <div>
                              <h3>FREE STUDY MATERIALS</h3>
                              <p>
                                Our templates make it easier for any student to
                                self-learn quickly from the framework and follow
                                them to achieve the best scores.
                              </p>
                            </div>
                          </li>
                          <li className="list4">
                            <span className="list-counting">
                              <svg
                                width="20"
                                height="25"
                                viewBox="0 0 20 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.0002 13.9532V6.48657M6.26684 10.2199H13.7335M18.7113 23.9088V7.48212C18.7113 5.39126 18.7113 4.34583 18.3044 3.54722C17.9465 2.84475 17.3753 2.27363 16.6729 1.9157C15.8742 1.50879 14.8288 1.50879 12.738 1.50879H7.2624C5.17153 1.50879 4.1261 1.50879 3.3275 1.9157C2.62503 2.27363 2.0539 2.84475 1.69597 3.54722C1.28906 4.34583 1.28906 5.39126 1.28906 7.48212V23.9088L10.0002 18.931L18.7113 23.9088Z"
                                  stroke="#FFB02C"
                                  strokeWidth="1.86667"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                            <div>
                              <h3>LATEST RESOURCES</h3>
                              <p>
                                Our students get access to our comprehensive
                                learning resources and online platform.
                              </p>
                            </div>
                          </li>
                          <li className="list5">
                            <span className="list-counting">
                              <svg
                                width="30"
                                height="31"
                                viewBox="0 0 30 31"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.41712 20.2452L5.79177 18.8744C5.92039 18.8001 6.07133 18.7743 6.21731 18.8017L10.8896 19.6761C11.2736 19.748 11.628 19.4524 11.6263 19.0617L11.6081 14.968C11.6076 14.8567 11.6369 14.7474 11.693 14.6514L14.0509 10.6146C14.1736 10.4045 14.1626 10.1422 14.0227 9.94309L10.0527 4.29217M23.7183 6.82258C16.8739 10.1091 20.607 14.4647 21.8517 15.0869C24.1876 16.2547 27.436 16.3313 27.436 16.3313C27.4462 16.1252 27.4514 15.9177 27.4514 15.7091C27.4514 8.83622 21.8798 3.26465 15.0069 3.26465C8.13407 3.26465 2.5625 8.83622 2.5625 15.7091C2.5625 22.582 8.13407 28.1535 15.0069 28.1535C15.2156 28.1535 15.423 28.1484 15.6292 28.1383M20.9277 28.0786L16.9869 17.689L27.3765 21.6299L22.7693 23.4715L20.9277 28.0786Z"
                                  stroke="#48A75C"
                                  strokeWidth="1.86667"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                            <div>
                              <h3>ONLINE SUPPORT</h3>
                              <p>
                                Our experts are always available for any
                                student. You can reach out to any trainer and
                                ask questions or seek help in solving any doubts
                                that you have.
                              </p>
                            </div>
                          </li>
                          <li className="list6">
                            <span className="list-counting">
                              <svg
                                width="22"
                                height="28"
                                viewBox="0 0 22 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M13.4913 1.59998V6.74021C13.4913 7.43716 13.4913 7.78564 13.627 8.05184C13.7463 8.286 13.9366 8.47637 14.1708 8.59568C14.437 8.73132 14.7855 8.73132 15.4824 8.73132H20.6227M20.958 11.2056V20.1802C20.958 22.2711 20.958 23.3165 20.5511 24.1151C20.1932 24.8176 19.622 25.3887 18.9196 25.7466C18.1209 26.1535 17.0755 26.1535 14.9847 26.1535H7.02021C4.92935 26.1535 3.88391 26.1535 3.08531 25.7466C2.38284 25.3887 1.81171 24.8176 1.45378 24.1151C1.04688 23.3165 1.04688 22.2711 1.04688 20.1802V7.23798C1.04688 5.14712 1.04688 4.10169 1.45378 3.30308C1.81171 2.60061 2.38284 2.02948 3.08531 1.67156C3.88391 1.26465 4.92935 1.26465 7.02021 1.26465H11.0171C11.9302 1.26465 12.3868 1.26465 12.8165 1.3678C13.1974 1.45926 13.5616 1.6101 13.8956 1.81479C14.2723 2.04567 14.5952 2.36851 15.2409 3.0142L19.2084 6.98177C19.8541 7.62745 20.177 7.9503 20.4078 8.32705C20.6125 8.66108 20.7634 9.02525 20.8548 9.40618C20.958 9.83584 20.958 10.2924 20.958 11.2056Z"
                                  stroke="#0286FF"
                                  strokeWidth="1.86667"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                            <div>
                              <h3>PAST EXAM QUESTIONS TO PRACTICE</h3>
                              <p>
                                We have a repository of past exam questions with
                                answers to practice from that can help any
                                student to quickly practice previous year's
                                questions.
                              </p>
                            </div>
                          </li>
                          <li className="list7">
                            <span className="list-counting">
                              <svg
                                width="28"
                                height="28"
                                viewBox="0 0 28 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11.5181 17.4424L7.69107 21.3173C7.15726 21.8577 6.89035 22.128 6.66093 22.147C6.46189 22.1636 6.26702 22.0836 6.13703 21.9319C5.98719 21.7572 5.98719 21.3773 5.98719 20.6177V18.6764C5.98719 17.9949 5.42908 17.5018 4.75475 17.403V17.403C3.12271 17.164 1.84098 15.8822 1.60192 14.2502C1.5625 13.9811 1.5625 13.66 1.5625 13.0177V7.23798C1.5625 5.14712 1.5625 4.10169 1.96941 3.30308C2.32734 2.60061 2.89846 2.02948 3.60094 1.67156C4.39954 1.26465 5.44497 1.26465 7.53583 1.26465H16.7447C18.8356 1.26465 19.881 1.26465 20.6796 1.67156C21.3821 2.02948 21.9532 2.60061 22.3111 3.30308C22.7181 4.10169 22.7181 5.14712 22.7181 7.23798V12.4646M22.7181 26.1535L20.0096 24.2705C19.6289 24.0059 19.4386 23.8735 19.2314 23.7797C19.0475 23.6964 18.8542 23.6358 18.6557 23.5992C18.432 23.558 18.2001 23.558 17.7364 23.558H15.5003C14.1064 23.558 13.4094 23.558 12.877 23.2867C12.4087 23.0481 12.0279 22.6673 11.7893 22.199C11.5181 21.6666 11.5181 20.9697 11.5181 19.5758V16.4469C11.5181 15.053 11.5181 14.356 11.7893 13.8236C12.0279 13.3553 12.4087 12.9745 12.877 12.7359C13.4094 12.4647 14.1064 12.4646 15.5003 12.4646H22.4692C23.8631 12.4646 24.56 12.4647 25.0924 12.7359C25.5608 12.9745 25.9415 13.3553 26.1801 13.8236C26.4514 14.356 26.4514 15.053 26.4514 16.4469V19.8247C26.4514 20.9843 26.4514 21.5642 26.2619 22.0216C26.0093 22.6314 25.5248 23.1159 24.915 23.3685C24.4576 23.558 23.8777 23.558 22.7181 23.558V26.1535Z"
                                  stroke="#FFB02C"
                                  strokeWidth="1.86667"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                            <div>
                              <h3>DISCUSSION SESSIONS</h3>
                              <p>
                                Our faculties carefully assess the level of
                                students during discussion sessions and suggest
                                personalized study plans.
                              </p>
                            </div>
                          </li>
                          <li className="list8">
                            <span className="list-counting">
                              <svg
                                width="30"
                                height="31"
                                viewBox="0 0 30 31"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.54028 14.464V19.4418M22.4736 11.9752V16.9529M21.2292 5.75293C24.2764 5.75293 25.9246 6.2193 26.7447 6.58104C26.8539 6.62921 26.9085 6.6533 27.0661 6.8037C27.1606 6.89386 27.333 7.1584 27.3774 7.28122C27.4514 7.48612 27.4514 7.59812 27.4514 7.82212V21.1979C27.4514 22.3288 27.4514 22.8943 27.2818 23.1849C27.1093 23.4806 26.9429 23.618 26.62 23.7317C26.3026 23.8434 25.6618 23.7202 24.3803 23.474C23.4833 23.3017 22.4195 23.1752 21.2292 23.1752C17.4958 23.1752 13.7625 25.664 8.78472 25.664C5.73744 25.664 4.08927 25.1977 3.2692 24.8359C3.15999 24.7878 3.10538 24.7637 2.94778 24.6133C2.85331 24.5231 2.68087 24.2586 2.63651 24.1358C2.5625 23.9309 2.5625 23.8189 2.5625 23.5948L2.5625 10.2191C2.5625 9.08815 2.5625 8.52269 2.73209 8.23204C2.9046 7.93639 3.07097 7.79894 3.39386 7.68532C3.71129 7.57362 4.35205 7.69673 5.63358 7.94296C6.53056 8.11531 7.59439 8.24182 8.78472 8.24182C12.5181 8.24182 16.2514 5.75293 21.2292 5.75293ZM18.1181 15.7085C18.1181 17.4267 16.7252 18.8196 15.0069 18.8196C13.2887 18.8196 11.8958 17.4267 11.8958 15.7085C11.8958 13.9903 13.2887 12.5974 15.0069 12.5974C16.7252 12.5974 18.1181 13.9903 18.1181 15.7085Z"
                                  stroke="#7F56D9"
                                  strokeWidth="1.86667"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                            <div>
                              <h3>AFFORDABLE FEES</h3>
                              <p>
                                We have kept the course fees reasonable so that
                                every student can easily afford to pay the costs
                                on their own.
                              </p>
                            </div>
                          </li>
                          <li className="list9">
                            <span className="list-counting">
                              <svg
                                width="30"
                                height="31"
                                viewBox="0 0 30 31"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M15.0069 8.24243V15.7091L19.9847 18.198M27.4514 15.7091C27.4514 22.582 21.8798 28.1535 15.0069 28.1535C8.13407 28.1535 2.5625 22.582 2.5625 15.7091C2.5625 8.83622 8.13407 3.26465 15.0069 3.26465C21.8798 3.26465 27.4514 8.83622 27.4514 15.7091Z"
                                  stroke="#0286FF"
                                  strokeWidth="1.86667"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                            <div>
                              <h3>REAL-TIME TEST ENVIRONMENT</h3>
                              <p>
                                We assess all our students from time to time and
                                give them a real-time test environment, so they
                                acclimate to the actual test environment and
                                feel less stressed during the actual test.
                              </p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="master-all-pte">
                <div className="container">
                  <div className="row">
                    <div className="master-all-header">
                      <h2 className="primary-heading fw-700 text-center text-white">
                        MASTER EVERY SECTION <br /> OF THE{" "}
                        <span className="wpl-badge pte-naati-badge text-white">
                          IELTS EXAM
                        </span>{" "}
                        WITH
                        <br />
                        OUR PROVEN STRATEGIES
                      </h2>
                      <p className="sub-heading text-center text-white">
                        Our specialized training helps you excel in every <br />{" "}
                        component of the PTE Core exam
                      </p>
                    </div>
                  </div>
                  <div className="master-all-tabs">
                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link active"
                          id="speak-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#speak-tab-pane"
                          type="button"
                          role="tab"
                          aria-controls="speak-tab-pane"
                          aria-selected="true"
                        >
                          <img
                            src="/images/web-new-images/icons/w-speak-icon.svg"
                            alt="Register Now"
                          />{" "}
                          Speaking
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="write-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#write-tab-pane"
                          type="button"
                          role="tab"
                          aria-controls="write-tab-pane"
                          aria-selected="false"
                        >
                          <img
                            src="/images/web-new-images/icons/w-write-icon.svg"
                            alt="Register Now"
                          />{" "}
                          Writing
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="profile-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#profile-tab-pane"
                          type="button"
                          role="tab"
                          aria-controls="profile-tab-pane"
                          aria-selected="false"
                        >
                          <img
                            src="/images/web-new-images/icons/w-reading-icon.svg"
                            alt="Register Now"
                          />{" "}
                          Reading
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="home-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#home-tab-pane"
                          type="button"
                          role="tab"
                          aria-controls="home-tab-pane"
                          aria-selected="false"
                        >
                          <img
                            src="/images/web-new-images/icons/w-listen-icon.svg"
                            alt="Register Now"
                          />{" "}
                          Listening
                        </button>
                      </li>
                    </ul>
                    <div className="tab-content" id="myTabContent">
                      <div
                        className="tab-pane fade"
                        id="home-tab-pane"
                        role="tabpanel"
                        aria-labelledby="home-tab"
                        tabIndex="0"
                      >
                        <div className="master-tab-cards">
                          <div className="test-card">
                            <h2>What It Tests</h2>
                            <ul>
                              <li>
                                Understanding accents, identifying details, and
                                following conversations.
                              </li>
                            </ul>
                          </div>
                          <div className="approach-card">
                            <div className="card-img">
                              <img
                                src="/images/web-new-images/icons/w-listen-icon.svg"
                                alt="Register Now"
                              />
                            </div>
                            <h2>Our Approach</h2>
                            <ul>
                              <li>
                                Active listening exercises, accent training, and
                                answering strategies.
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="profile-tab-pane"
                        role="tabpanel"
                        aria-labelledby="profile-tab"
                        tabIndex="0"
                      >
                        <div className="master-tab-cards">
                          <div className="test-card">
                            <h2>What It Tests</h2>
                            <ul>
                              <li>
                                Vocabulary, speed, and critical reading skills.
                              </li>
                            </ul>
                          </div>
                          <div className="approach-card">
                            <div className="card-img">
                              <img
                                src="/images/web-new-images/icons/w-reading-icon.svg"
                                alt="Register Now"
                              />
                            </div>
                            <h2>Our Approach</h2>
                            <ul>
                              <li>
                                Time management techniques, skimming /scanning,
                                and comprehension-building exercises.
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="write-tab-pane"
                        role="tabpanel"
                        aria-labelledby="write-tab"
                        tabIndex="0"
                      >
                        <div className="master-tab-cards">
                          <div className="test-card">
                            <h2>What It Tests</h2>
                            <ul>
                              <li>
                                Grammar, essay structuring, and articulation of
                                ideas.
                              </li>
                            </ul>
                          </div>
                          <div className="approach-card">
                            <div className="card-img">
                              <img
                                src="/images/web-new-images/icons/w-write-icon.svg"
                                alt="Register Now"
                              />
                            </div>
                            <h2>Our Approach</h2>
                            <ul>
                              <li>
                                Learn high-scoring templates, refine grammar,
                                and structure essays effectively.
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade show active"
                        id="speak-tab-pane"
                        role="tabpanel"
                        aria-labelledby="speak-tab"
                        tabIndex="0"
                      >
                        <div className="master-tab-cards">
                          <div className="test-card">
                            <h2>What It Tests</h2>
                            <ul>
                              <li>
                                Fluency, pronunciation, and clarity of
                                expression.
                              </li>
                            </ul>
                          </div>
                          <div className="approach-card">
                            <div className="card-img">
                              <img
                                src="/images/web-new-images/icons/w-speak-icon.svg"
                                alt="Register Now"
                              />
                            </div>
                            <h2>Our Approach</h2>
                            <ul>
                              <li>
                                Practice with mock interviews, fluency drills,
                                and AI-supported pronunciation tools.
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row master-all-footer">
                    <div className="col-md-12 text-center">
                      <Link className="primary-btn" to="/auth/register">
                        <span className="btn-inner">
                          READY TO EXCEL IN EVERY SECTION OF THE IELTS TEST?
                          ENROLL WITH US NOW{" "}
                          <img
                            src="/images/web-new-images/right-arrow.svg"
                            alt="Register Now"
                          />
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="ielts-achievment">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-6 text-center">
                  <h2 className="primary-heading fw-700">
                    OUR SUCCESS <br /> RECORD & student
                    <br />
                    <span className="wpl-badge text-white">ACHIEVEMENTS</span>
                  </h2>
                </div>
                <div className="col-md-6">
                  <div className="achievment-card">
                    <div className="icon-wrapper">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 21.6885L11.8999 21.5384C11.2053 20.4964 10.858 19.9754 10.3991 19.5983C9.99286 19.2644 9.52476 19.0139 9.02161 18.8611C8.45325 18.6885 7.82711 18.6885 6.57482 18.6885H5.2C4.07989 18.6885 3.51984 18.6885 3.09202 18.4705C2.71569 18.2787 2.40973 17.9728 2.21799 17.5965C2 17.1686 2 16.6086 2 15.4885V6.88848C2 5.76837 2 5.20832 2.21799 4.7805C2.40973 4.40417 2.71569 4.09821 3.09202 3.90646C3.51984 3.68848 4.07989 3.68848 5.2 3.68848H5.6C7.84021 3.68848 8.96031 3.68848 9.81596 4.12445C10.5686 4.50794 11.1805 5.11987 11.564 5.87251C12 6.72816 12 7.84827 12 10.0885M12 21.6885V10.0885M12 21.6885L12.1001 21.5384C12.7947 20.4964 13.142 19.9754 13.6009 19.5983C14.0071 19.2644 14.4752 19.0139 14.9784 18.8611C15.5467 18.6885 16.1729 18.6885 17.4252 18.6885H18.8C19.9201 18.6885 20.4802 18.6885 20.908 18.4705C21.2843 18.2787 21.5903 17.9728 21.782 17.5965C22 17.1686 22 16.6086 22 15.4885V6.88848C22 5.76837 22 5.20832 21.782 4.7805C21.5903 4.40417 21.2843 4.09821 20.908 3.90646C20.4802 3.68848 19.9201 3.68848 18.8 3.68848H18.4C16.1598 3.68848 15.0397 3.68848 14.184 4.12445C13.4314 4.50794 12.8195 5.11987 12.436 5.87251C12 6.72816 12 7.84827 12 10.0885"
                          stroke="#94C23C"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="achievment-content">
                      <h2>OUR IMPRESSIVE STATISTICS</h2>
                      <ul>
                        <li>500+ Coaching Preview Sessions Completed</li>
                        <li>500+ Registered Students</li>
                        <li>
                          200+ Successful Students Achieving Target Scores
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="sss-section">
            <CrackedCodeSlider title={`<span className="fw-700">HEAR FROM</span> <br className="d-block" /><span className="wpl-badge pte-naati-badge text-white">our students</span>`} />
            <div className="container">
              <div className="text-center bottom-btn-wrapper">
                <p className="sub-heading">
                  We're dedicated to your success because your dreams matter to
                  us.
                </p>
                <Link to="#" className="primary-btn">
                  JOIN OUR SUCCESS STORIES
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </Link>
              </div>
            </div>
          </div>


          <div className="ielts-get">
            <div className="container">    
              <h2 className="primary-heading fw-700 text-center">
                WHAT YOU WILL
                <br />
                get <span className="wpl-badge pte-naati-badge text-white">WITH US</span>
              </h2>       
              <h2 className="comprehensive-title text-white">            
              Our comprehensive IELTS preparation package includes
              </h2>
              <div className="plan-cards">
                <div className="plan-card-outer">
                  <div className="plan-card">
                    <div className="icon-wrapper">
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.49072L6 12.4907L1 7.49072"
                          stroke="#48A75C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="content-wrapper">
                      <h2>Unlimited Classes</h2>
                      <p>
                        Attend as many sessions as you need until you master every IELTS skill
                      </p>
                    </div>
                  </div>
                </div>
                <div className="plan-card-outer">
                  <div className="plan-card">
                    <div className="icon-wrapper">
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.49072L6 12.4907L1 7.49072"
                          stroke="#48A75C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="content-wrapper">
                      <h2>Unlimited Writing & Speaking Assessments</h2>
                      <p>
                        Get continuous feedback to perfect your weakest areas without restrictions
                      </p>
                    </div>
                  </div>
                </div>
                <div className="plan-card-outer">
                  <div className="plan-card">
                    <div className="icon-wrapper">
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.49072L6 12.4907L1 7.49072"
                          stroke="#48A75C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="content-wrapper">
                      <h2>1-to-1 Tutorial with Expert Tutor</h2>
                      <p>
                        Receive personalized attention tailored to your specific learning needs and goals
                      </p>
                    </div>
                  </div>
                </div>
                <div className="plan-card-outer">
                  <div className="plan-card">
                    <div className="icon-wrapper">
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.49072L6 12.4907L1 7.49072"
                          stroke="#48A75C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="content-wrapper">
                      <h2>Comprehensive Practice Question Bank</h2>
                      <p>
                        Access thousands of real exam-style questions to build unshakeable confidence
                      </p>
                    </div>
                  </div>
                </div>
                <div className="plan-card-outer">
                  <div className="plan-card">
                    <div className="icon-wrapper">
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.49072L6 12.4907L1 7.49072"
                          stroke="#48A75C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="content-wrapper">
                      <h2>Proven Method Lessons</h2>
                      <p>
                        Learn insider techniques and strategies that consistently produce high band scores
                      </p>
                    </div>
                  </div>
                </div>
                 <div className="plan-card-outer">
                  <div className="plan-card">
                    <div className="icon-wrapper">
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.49072L6 12.4907L1 7.49072"
                          stroke="#48A75C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="content-wrapper">
                      <h2>Foundation <br /> Overview Classes</h2>
                      <p>
                        Build rock-solid fundamentals before diving into advanced test-taking strategies
                      </p>
                    </div>
                  </div>
                </div>
                <div className="plan-card-outer">
                  <div className="plan-card">
                    <div className="icon-wrapper">
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.49072L6 12.4907L1 7.49072"
                          stroke="#48A75C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="content-wrapper">
                      <h2>Strategic Pre-Test Preparation Sessions</h2>
                      <p>
                        Enter your exam with a winning game plan and zero surprises
                      </p>
                    </div>
                  </div>
                </div>
                <div className="plan-card-outer">
                  <div className="plan-card">
                    <div className="icon-wrapper">
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.49072L6 12.4907L1 7.49072"
                          stroke="#48A75C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="content-wrapper">
                      <h2>Post-Test Success Consultations</h2>
                      <p>
                        Get expert analysis of your results and guidance for future improvement
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-center ielts-get-btn">
                  <Link to="#" className="primary-btn">
                  EXPERIENCE OUR COMPREHENSIVE APPROACH
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </Link>
              </div>
               <div className="ielts-journey">
                  <div className="ielts-journey-header">
                      <h2 className="primary-heading fw-700 text-center">
                      <span className="wpl-badge gold-badge text-white">START YOUR IELTS</span>
                      <br />
                      JOURNEY TODAY
                      </h2>
                      <div className="journey-sub-heading">
                        <p>Choose Your <br /> Preparation Package</p>
                        <div className="price-btn">
                          <span>Starting<br />from</span> <span className="price">$349</span>
                        </div>
                      </div>
                  </div>
                  <div className="ielts-journey-content">
                    <div className="text-start text-md-center">
                      <span className="ielts-badge">PACKAGE OPTION 1</span>
                    </div>
                    <h2>ONLINE COACHING</h2>
                    <p>Everything in the Online Platform package, PLUS</p>
                    <ul>
                      <li>
                        <h3>
                          <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect y="0.444824" width="40" height="40" rx="20" fill="#48A75C" fillOpacity="0.12"/>
                          <path d="M28 14.4448L17 25.4448L12 20.4448" stroke="#48A75C" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                          LIVE VIRTUAL CLASSES</h3>
                          <p>Join expert-led sessions focusing on each component of the exam</p>
                      </li>
                      <li>
                        <h3>
                          <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect y="0.444824" width="40" height="40" rx="20" fill="#48A75C" fillOpacity="0.12"/>
                          <path d="M28 14.4448L17 25.4448L12 20.4448" stroke="#48A75C" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                          PERSONALIZED FEEDBACK</h3>
                          <p>Receive detailed analysis of your performance with specific improvement strategies</p>
                      </li>
                      <li>
                        <h3>
                          <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect y="0.444824" width="40" height="40" rx="20" fill="#48A75C" fillOpacity="0.12"/>
                          <path d="M28 14.4448L17 25.4448L12 20.4448" stroke="#48A75C" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                          DIRECT TRAINER ACCESS</h3>
                          <p>Get your questions answered directly by our experienced instructors</p>
                      </li>
                      <li>
                        <h3>
                          <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect y="0.444824" width="40" height="40" rx="20" fill="#48A75C" fillOpacity="0.12"/>
                          <path d="M28 14.4448L17 25.4448L12 20.4448" stroke="#48A75C" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                          PRIORITY SUPPORT</h3>
                          <p>Fast-track assistance whenever you face challenges in your preparation</p>
                      </li>
                    </ul>
                  </div>
                  <div className="text-center">
                      <Link to="#" className="primary-btn">
                      Book Classes
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </Link>
                  </div>
                </div>       
            </div>
          </div> 

          <div className="faq-section">
            <div className="container">
              <div className="row">
                <h2 className="secondary-heading text-center">
                  Frequently Asked Questions
                </h2>
                <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                       How long will I need to prepare for IELTS?
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                       Most candidates typically need 6-8 weeks of focused preparation depending on their current skill level.
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        Do Premium and VIP Plans guarantee results?
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque facilis, voluptates saepe cupiditate fugit quod hic doloribus corrupti excepturi ea quisquam nesciunt repellendus, rerum accusantium sed nostrum, fugiat quaerat quas?
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingThree">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        Are classes available online or in-person in Parramatta?
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Totam laboriosam aliquid iure architecto reiciendis dicta, aliquam vero soluta expedita itaque libero hic corrupti. Veritatis accusantium, facere officiis saepe facilis culpa!
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFour">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        How can I book a free demo class?
                      </button>
                    </h2>
                    <div
                      id="collapseFour"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Totam laboriosam aliquid iure architecto reiciendis dicta, aliquam vero soluta expedita itaque libero hic corrupti. Veritatis accusantium, facere officiis saepe facilis culpa!
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingFive">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFive"
                        aria-expanded="false"
                        aria-controls="collapseFive"
                      >
                        What makes Language Academy different from other IELTS coaching centers?
                      </button>
                    </h2>
                    <div
                      id="collapseFive"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFive"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Totam laboriosam aliquid iure architecto reiciendis dicta, aliquam vero soluta expedita itaque libero hic corrupti. Veritatis accusantium, facere officiis saepe facilis culpa!
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingSix">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSix"
                        aria-expanded="false"
                        aria-controls="collapseSix"
                      >
                        Where exactly is your Parramatta campus located?
                      </button>
                    </h2>
                    <div
                      id="collapseSix"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingSix"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Totam laboriosam aliquid iure architecto reiciendis dicta, aliquam vero soluta expedita itaque libero hic corrupti. Veritatis accusantium, facere officiis saepe facilis culpa!
                      </div>
                    </div>
                  </div>
                   <div className="accordion-item">
                    <h2 className="accordion-header" id="headingNine">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseNine"
                        aria-expanded="false"
                        aria-controls="collapseNine"
                      >
                        What is the difference between IELTS Academic and General Training?
                      </button>
                    </h2>
                    <div
                      id="collapseNine"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingNine"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Totam laboriosam aliquid iure architecto reiciendis dicta, aliquam vero soluta expedita itaque libero hic corrupti. Veritatis accusantium, facere officiis saepe facilis culpa!
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingSeven">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSeven"
                        aria-expanded="false"
                        aria-controls="collapseSeven"
                      >
                        Do you provide past exam questions for practice?
                      </button>
                    </h2>
                    <div
                      id="collapseSeven"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingSeven"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Totam laboriosam aliquid iure architecto reiciendis dicta, aliquam vero soluta expedita itaque libero hic corrupti. Veritatis accusantium, facere officiis saepe facilis culpa!
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingEight">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseEight"
                        aria-expanded="false"
                        aria-controls="collapseEight"
                      >
                        What kind of support do you provide during the course?
                      </button>
                    </h2>
                    <div
                      id="collapseEight"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingEight"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Totam laboriosam aliquid iure architecto reiciendis dicta, aliquam vero soluta expedita itaque libero hic corrupti. Veritatis accusantium, facere officiis saepe facilis culpa!
                      </div>
                    </div>
                  </div>



                </div>
              </div>
            </div>
          </div>
          <Footer />
          <div
            className="modal fade"
            id="staticBackdrop"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog main-popup">
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">
                      <img
                        className="img-fluid"
                        src="/images/web-new-images/icons/close-icon2.svg"
                        alt="LA"
                      />
                    </span>
                  </button>
                </div>
                <div className="modal-body p-0">
                  <div className="form-content-outer m-0">
                    <div className="form-content">
                      <div className="main-popup-img form-img">
                        <img
                          className="img-fluid"
                          src="/images/web-new-images/hero_img1.png"
                          alt="LA"
                        />
                      </div>
                      <div className="main-popup-content form-content-right">
                        <h4 className="popup-title">Take a FREE Demo Class</h4>
                        <p className="popup-sub-title">
                          Submit Your Details Below
                        </p>
                        <div className="pte-popup-form-start">
                          <form onSubmit={this.submitForm}>
                            <div className="fieldOuter">
                              <label htmlFor="name">Name*</label>
                              <div className="form-input-outer">
                                <input
                                  className="form-input"
                                  type="text"
                                  name="name"
                                  placeholder="Name*"
                                  value={this.state.name}
                                  onChange={(e) => {
                                    this.changeInput(e);
                                  }}
                                />
                              </div>
                              {this.validator.message(
                                "Name",
                                this.state.name,
                                "required"
                              )}
                            </div>
                            <div className="fieldOuter">
                              <label htmlFor="PhoneNumber">Phone Number</label>
                              <PhoneInputField
                                id="PhoneNumber"
                                value={this.state.phone}
                                changeEvent={this.handlePhoneChange}
                                addClass="popup-class"
                              />
                              {this.validator.message(
                                "phone",
                                this.state.phone,
                                "required|phone"
                              )}
                              <span className="err phone-error"></span>
                            </div>
                            <div className="fieldOuter">
                              <label htmlFor="email">Email*</label>
                              <div className="form-input-outer">
                                <input
                                  className="form-input"
                                  type="email"
                                  name="email"
                                  placeholder="Email*"
                                  value={this.state.email}
                                  onChange={(e) => {
                                    this.changeInput(e);
                                  }}
                                />
                              </div>
                              {this.validator.message(
                                "Email",
                                this.state.email,
                                "required"
                              )}
                            </div>
                            {/* <div className="fieldOuter">
                                    <input
                                      type="text"
                                      name="phone"
                                      placeholder="Phone*"
                                      value={this.state.phone}
                                      onChange={(e) => { this.changeInput(e)} }
                                    />
                                    {this.validator.message('Phone', this.state.phone, 'required')}
                                  </div> */}
                            <div className="fieldOuter">
                              <label htmlFor="center">Center</label>
                              <div className="form-input-outer form-select-wrapper">
                                <select
                                  className="form-input"
                                  id="center"
                                  name="course"
                                  value={this.state.course}
                                  onChange={(e) => {
                                    this.changeInput(e);
                                  }}
                                >
                                  <option value="NAATI CCL Online">
                                    NAATI CCL Online
                                  </option>
                                  <option value="PTE On-Campus">
                                    PTE On-Campus
                                  </option>
                                  <option value="PTE Online4">
                                    PTE Online
                                  </option>
                                  <option value="NAATI CCL On-Campus">
                                    NAATI CCL On-Campus
                                  </option>
                                  <option value="IELTS Online1">
                                    IELTS Online
                                  </option>
                                  <option value="IELTS On-Campus1">
                                    IELTS On-Campus
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div className="fieldOuter">
                              <label htmlFor="comments">Language</label>
                              <div className="form-input-outer form-select-wrapper">
                                <select
                                  className="form-input"
                                  name="lang"
                                  value={this.state.lang}
                                  onChange={(e) => {
                                    this.changeInput(e);
                                  }}
                                >
                                  <option value="Hindi">Hindi</option>
                                  <option value="Punjabi">Punjabi</option>
                                  <option value="Urdu">Urdu</option>
                                  <option value="Nepali">Nepali</option>
                                  <option value="Bangla">Bangla</option>
                                  <option value="Tamil">Tamil</option>
                                  <option value="Telugu">Telugu</option>
                                  <option value="Sinhalese">Sinhalese</option>
                                </select>
                              </div>
                            </div>
                            <div className="fieldOuter">
                              <label htmlFor="comments">Comments / Query</label>
                              <div className="form-input-outer">
                                <input
                                  type="text"
                                  className="form-input"
                                  name="comments"
                                  placeholder="Enter your comments/Query"
                                  value={this.state.query}
                                  onChange={(e) => {
                                    this.changeInput(e);
                                  }}
                                />
                              </div>
                              {this.validator.message(
                                "Query",
                                this.state.query,
                                "required"
                              )}
                            </div>
                            <div className="fieldOuter mb-0">
                              {!this.state.loginLock && (
                                <button
                                  className="primary-btn"
                                  onClick={(e) => {
                                    this.hitApi();
                                  }}
                                >
                                  SUBMIT{" "}
                                  <img
                                    className="img-fluid"
                                    src="/images/web-new-images/right-arrow.svg"
                                    alt="LA"
                                  />
                                </button>
                              )}
                              {this.state.loginLock && (
                                <button className="primary-btn">Wait...</button>
                              )}
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default Pte;
